import React, { useEffect, useState } from 'react';
import { api } from '../../../services/api.js';
import './RestauranteSelector.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';
import { FaUserTie, FaCheckCircle } from 'react-icons/fa';

const RestauranteSelector = ({ usuario, onSelecionar, bloqueado }) => {
  const [restaurantes, setRestaurantes] = useState([]);
  const [erro, setErro] = useState(null);
  const chapa = localStorage.getItem("chapa");

  const renderStars = (nota) => {
    const rounded = Math.round(nota * 2) / 2;
    const full = Math.floor(rounded);
    const half = rounded % 1 !== 0;
    const empty = 5 - full - (half ? 1 : 0);
  
    const starClass = () => `text-warning me-1 star-blink`;
    const getDelay = (i) => ({ animationDelay: `${i * 0.2}s` });
  
    const stars = [];
  
    for (let i = 0; i < full; i++) {
      stars.push(
        <FontAwesomeIcon
          key={`full-${i}`}
          icon={solidStar}
          className={starClass(i)}
          style={getDelay(i)}
        />
      );
    }
  
    if (half) {
      stars.push(
        <FontAwesomeIcon
          key={`half`}
          icon={faStarHalfAlt}
          className={starClass(full)}
          style={getDelay(full)}
        />
      );
    }
  
    for (let i = 0; i < empty; i++) {
      stars.push(
        <FontAwesomeIcon
          key={`empty-${i}`}
          icon={regularStar}
          className={starClass(full + (half ? 1 : 0) + i)}
          style={getDelay(full + (half ? 1 : 0) + i)}
        />
      );
    }
  
    return <>{stars}</>;
  };

  useEffect(() => {
    const fetchRestaurantes = async () => {
      const lojaUsuario = localStorage.getItem("loja");
      try {
        const res = await api.get(`/restaurante/${chapa}?codigo=0&loja=${lojaUsuario}`);
        if (Array.isArray(res.data)) {
          setRestaurantes(res.data);
          setErro(null);
        } else {
          setErro('Dados inválidos recebidos do servidor.');
        }
      } catch (err) {
        console.error('Erro ao buscar restaurantes:', err);

        if (err.message === 'Network Error') {
          setErro('Falha no acesso ao servidor');
        } else if (err.response && err.response.data) {
          setErro(`Erro: ${err.response.data.erro || 'Erro inesperado'}`);
        } else {
          setErro('Erro inesperado ao buscar restaurantes.');
        }
      }
    };

    fetchRestaurantes();
  }, [usuario, chapa]);

  if (erro) {
    return (
      <div className="alert alert-danger rounded-4 border-0 shadow-sm" role="alert">
        {erro}
      </div>
    );
  }

  return (
    <div className="row g-3">
      {restaurantes.map((rest) => (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={rest.codigo}>
          <div className={`card h-100 border-0 shadow-sm rounded-4 overflow-hidden ${bloqueado ? 'bg-light opacity-75' : 'bg-white hover-card'}`}>
            <div className="card-body p-3 d-flex flex-column justify-content-between">
              <div>
                {/* CABEÇALHO CORRIGIDO: Texto visível em branco e alinhamento ajustado */}
                <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
                  <h6 className="fw-bold text-dark m-0 fs-6" style={{ lineHeight: '1.3' }}>
                    {rest.nomeamigavel}
                  </h6>
                  <span className="badge bg-danger text-white fw-bold extra-small px-2 py-1 flex-shrink-0">
                    Cód {rest.codigo}
                  </span>
                </div>

                <p className="extra-small text-muted mb-2 d-flex align-items-center">
                  <FaUserTie className="me-1.5 text-secondary" /> {rest.responsavel || 'Não especificado'}
                </p>

                <div className="p-2 bg-light rounded-3 mb-3 d-flex align-items-center justify-content-between">
                  <small className="extra-small text-muted fw-bold">Avaliação:</small>
                  <div>
                    {rest.avaliacao != null ? (
                      <>
                        <span className="fw-bold text-dark me-1 small">{Number(rest.avaliacao).toFixed(1)}</span>
                        {renderStars(Number(rest.avaliacao))}
                      </>
                    ) : (
                      <span className="extra-small text-muted">Sem avaliação</span>
                    )}
                  </div>
                </div>
              </div>

              <button
                className="btn btn-sm w-100 fw-bold border-0 py-2 rounded-3 text-white d-flex align-items-center justify-content-center gap-1.5"
                style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
                disabled={bloqueado}
                onClick={() => onSelecionar(rest)}
              >
                <FaCheckCircle size={14} /> Selecionar
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RestauranteSelector;